import countries from 'i18n-iso-countries';
import Danish from 'i18n-iso-countries/langs/da.json';
import German from 'i18n-iso-countries/langs/de.json';
import English from 'i18n-iso-countries/langs/en.json';
import Spanish from 'i18n-iso-countries/langs/es.json';
import French from 'i18n-iso-countries/langs/fr.json';
import Italian from 'i18n-iso-countries/langs/it.json';
import Japanese from 'i18n-iso-countries/langs/ja.json';
import Korean from 'i18n-iso-countries/langs/ko.json';
import Polish from 'i18n-iso-countries/langs/pl.json';
import Portuguese from 'i18n-iso-countries/langs/pt.json';
import Russian from 'i18n-iso-countries/langs/ru.json';
import Swedish from 'i18n-iso-countries/langs/sv.json';
import Ukrainian from 'i18n-iso-countries/langs/uk.json';
import Chinese from 'i18n-iso-countries/langs/zh.json';

const COUNTRY_LOCALES = {
  da: Danish,
  de: German,
  en: English,
  es: Spanish,
  fr: French,
  it: Italian,
  ja: Japanese,
  ko: Korean,
  pl: Polish,
  pt: Portuguese,
  'pt-BR': Portuguese,
  ru: Russian,
  sv: Swedish,
  uk: Ukrainian,
  zh: Chinese,
  'zh-TW': Chinese,
};

export const resolveCountryLocale = (language = 'en') => {
  if (COUNTRY_LOCALES[language]) {
    return language;
  }

  const baseLanguage = language.split('-')[0];
  if (COUNTRY_LOCALES[baseLanguage]) {
    return baseLanguage;
  }

  return 'en';
};

export const registerCountryLocale = (language) => {
  const locale = resolveCountryLocale(language);
  countries.registerLocale(COUNTRY_LOCALES[locale]);
  return locale;
};
